import { cn } from "../../utils/cn";

// The provider's own string, shown *under* the admin-curated label that replaced it
// (`preferred_name` on a venue or an artist, `preferred_title` on an event) so the record
// stays identifiable while both strings are on screen. The curated value is the heading —
// see `displayLabel` in `utils/helpers` — and this is the footnote, which is why it renders
// nothing when there is no curated value or when it says exactly what the provider said.
//
// Merged through `cn`, not concatenated: `.text-xs` is emitted after `.text-sm` in the
// stylesheet, so a plain `"text-xs " + className` would silently ignore a caller's `text-sm`.
export const ProviderLabel = ({ preferred, original, className }) =>
  preferred && original && preferred !== original ? (
    <p className={cn("text-xs text-muted-foreground", className)}>Provider: {original}</p>
  ) : null;
